import React from "react";
import { useMyDocumentsRelatingToPublisher } from "@seabrookstudios/pitch2table";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";
import { Path } from "../Path";
import Alert from "@mui/material/Alert";
import { usePublisherIdFromRoute } from "../games/WithGameIdFromRoute";
import { NonGameContractFromRoute } from "../sellsheets/ContractFromRoute";
import { AddContractToPublisher } from "../games/contracts/AddContractDialog";
import { MyPublisherDocumentListEntry } from "./ListItem";

const NoDocumentsFound = () => (
  <NoItemsFound>
    <Alert severity="info">
      Upload any contracts you have with this publisher that don't belong to a particular game e.g. NDA. Any other
      contracts that relate to a specific game will also be shown here but must be uploaded from the respective game.
    </Alert>
  </NoItemsFound>
);

export const PublishersDocumentsListAndDetail = () => {
  const publisherId = usePublisherIdFromRoute();
  const Action = () => <AddContractToPublisher publisherId={publisherId} />;
  const useMakeList = useMakeListBuilder(
    MyPublisherDocumentListEntry,
    idExtractor,
    "Documents",
    NoDocumentsFound,
    Action,
    undefined,
    Path.publisher(publisherId).link()
  );

  const useWrappedHook = () => useMyDocumentsRelatingToPublisher(publisherId);

  const ListAndDetail = useMakeListAndDetail(
    useWrappedHook,
    [],
    "publisher-documents",
    useMakeList,
    NonGameContractFromRoute
  );

  return <ListAndDetail />;
};
